import {API_URL} from "../../../../URL";
import {SET_BOARD_STYLES} from "../../../constants";

export const BoardStyleAPI = (id) => {
    return async(dispatch) => {
        // const data = await (await fetch(`${API_URL}/get/board_backgrounds/`)).json();
        const response = await fetch(`${API_URL}/get/board_backgrounds/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                user_id: id
            })
        })
        const data = await response.json();
        dispatch({type: SET_BOARD_STYLES, payload: data});
    }
}